import getRegionalOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('selectDateFormatOption', function selectDateFormatOption(dateFormat) {
    var optionState = getRegionalOptions();
    optionState.selectedDateFormat = dateFormat;
});
//# sourceMappingURL=selectDateFormatOption.js.map